// Brand assets & external links
export const BYMAT_LOGO =
  "https://customer-assets.emergentagent.com/job_blissful-saha-5/artifacts/2yvhyuu4_BYMAT_LOGO_1.png";

export const BOOK_COVER =
  "https://customer-assets.emergentagent.com/job_blissful-saha-5/artifacts/a2lue9u5_Book_front_cover1.jpeg";

export const BOOK_ORDER_URL = "https://rzp.io/l/ridingthesuccesswave";
